// Generated from the database by server/src/gen-types.ts. Don't edit; add a migration instead.

export interface ApiToken {
  id: string;
  user_id: string;
  name: string;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface AppUser {
  id: string;
  email: string;
  name: string;
  role: "admin" | "inventory" | "receiving";
  active: boolean;
  avatar_url: string;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
  can_pay: boolean;
  kind: "person" | "workstation";
}

export interface Attachment {
  id: string;
  owner_type: "production_run" | "production_cost" | "production_event" | "tooling_item" | "po" | "bill" | "payment" | "wise_transfer" | "presale_income" | "landed_cost";
  owner_id: string;
  kind: "invoice" | "receipt" | "quote" | "photo" | "report" | "email" | "other";
  filename: string;
  content_type: string;
  size: number;
  sha256: string;
  note: string;
  doc_date: string | null;
  uploaded_by: string | null;
  created_at: string;
}

export interface AuditLog {
  id: number;
  at: string;
  user_id: string | null;
  via: string;
  action: string;
  entity: string | null;
  entity_id: string | null;
  before: unknown | null;
  after: unknown | null;
  portal_contact_id: string | null;
}

export interface B2bDemand {
  id: string;
  item_id: string;
  qty: number;
  due_date: string;
  note: string;
  done: boolean;
  created_at: string;
  updated_at: string;
}

export interface Bill {
  id: string;
  number: string;
  vendor_id: string;
  kind: "deposit" | "balance" | "full" | "freight" | "duty" | "tooling" | "other";
  invoice_number: string;
  bill_date: string | null;
  due_date: string | null;
  currency: string;
  amount: number;
  status: "draft" | "approved" | "scheduled" | "paid" | "void";
  description: string;
  notes: string;
  paid_on: string | null;
  approved_by: string | null;
  approved_at: string | null;
  match_key: string;
  match_note: string;
  match_accepted_by: string | null;
  match_accepted_at: string | null;
  source: "manual" | "po" | "wise_history" | "import" | "portal";
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface BillLine {
  id: string;
  bill_id: string;
  position: number;
  kind: "goods" | "deposit" | "deposit_credit" | "charge" | "other" | "rounding";
  description: string;
  po_id: string | null;
  po_line_id: string | null;
  receipt_id: string | null;
  production_cost_id: string | null;
  tooling_item_id: string | null;
  credit_bill_id: string | null;
  qty: number | null;
  unit_price: number | null;
  amount: number;
  marked_paid: boolean;
  created_at: string;
  updated_at: string;
}

export interface Bin {
  id: string;
  location_id: string;
  code: string;
  name: string;
  is_default: boolean;
  active: boolean;
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface Bom {
  id: string;
  shopify_product_id: string | null;
  item_id: string | null;
  revision: number;
  status: "draft" | "active" | "retired";
  effective_from: string | null;
  make_vendor_id: string | null;
  phantom: boolean;
  notes: string;
  created_at: string;
  updated_at: string;
  section_order: string[];
  project_ids: string[];
  change_note: string;
}

export interface BomLine {
  id: string;
  bom_id: string;
  position: number;
  component_item_id: string | null;
  qty: number;
  scrap_pct: number;
  ref_designator: string;
  is_packaging: boolean;
  supply: "hhl_consigns" | "cm_buys" | "cm_makes";
  applies_when: unknown;
  option_name: string;
  notes: string;
  created_at: string;
  updated_at: string;
  section: string;
}

export interface BomOptionMap {
  id: string;
  bom_line_id: string;
  option_value: string;
  component_item_id: string;
  created_at: string;
  updated_at: string;
}

export interface BomOverride {
  id: string;
  bom_line_id: string;
  variant_item_id: string;
  qty: number | null;
  component_item_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface BuildCharge {
  id: string;
  shopify_product_id: string | null;
  item_id: string | null;
  position: number;
  name: string;
  amount: number | null;
  per: "unit" | "order";
  layer: "materials" | "assembly" | "packaging" | "tooling";
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface ChangeNotice {
  id: string;
  number: string;
  title: string;
  body_md: string;
  status: "draft" | "released";
  effective: "next_po" | "date";
  effective_date: string | null;
  released_by: string | null;
  released_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  source_url: string;
}

export interface ChangeNoticeItem {
  id: string;
  change_notice_id: string;
  item_id: string;
}

export interface CmCount {
  id: string;
  number: string;
  location_id: string;
  status: "submitted" | "approved" | "rejected";
  counted_at: string;
  make_order_id: string | null;
  notes: string;
  entered_by: string | null;
  decided_by: string | null;
  decided_at: string | null;
  decision_notes: string;
  created_at: string;
  updated_at: string;
  decisions: unknown;
}

export interface CmCountLine {
  id: string;
  count_id: string;
  item_id: string;
  counted: number;
  expected: number;
  in_transit: number;
  variance: number;
  unit_cost: number | null;
  in_shopify: boolean;
  created_at: string;
  outcome: "" | "adjusted" | "superseded" | "awaiting_delivery" | "shopify";
  adjusted: number | null;
}

export interface CmReport {
  id: string;
  kind: "output" | "scrap";
  location_id: string;
  make_order_id: string | null;
  qty_output: number;
  auto: boolean;
  notes: string;
  reported_at: string;
  reported_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface CmReportLine {
  id: string;
  report_id: string;
  item_id: string;
  kind: "consume" | "scrap" | "output";
  qty: number;
  reason: "" | "defective" | "damaged" | "lost" | "setup" | "other";
  in_shopify: boolean;
  notes: string;
  created_at: string;
}

export interface ConsignShipment {
  id: string;
  number: string;
  direction: "to_cm" | "to_hhl";
  cm_location_id: string;
  hhl_location_id: string;
  status: "shipped" | "received";
  carrier: string;
  tracking: string;
  eta: string | null;
  notes: string;
  shipped_at: string;
  shipped_by: string | null;
  received_at: string | null;
  received_by: string | null;
  receive_notes: string;
  created_at: string;
  updated_at: string;
}

export interface ConsignShipmentLine {
  id: string;
  shipment_id: string;
  position: number;
  item_id: string;
  qty: number;
  qty_received: number | null;
  hhl_bin_id: string | null;
  unit_cost: number | null;
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface CountDay {
  id: string;
  day: string;
  units_budget: number;
  skus_budget: number;
  made_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface CountTask {
  id: string;
  day: string;
  item_id: string;
  location_id: string;
  position: number;
  reason: "running_low" | "never" | "due" | "picked";
  on_hand: number;
  count_id: string | null;
  created_at: string;
  updated_at: string;
  units_90: number;
  top: boolean;
  last_counted: string | null;
  score: number;
  picked_by: string | null;
  dropped: boolean;
}

export interface DocAccess {
  id: string;
  doc_link_id: string | null;
  po_id: string | null;
  spec_revision_id: string | null;
  file_version_id: string | null;
  kind: "view" | "download" | "ack" | "label";
  at: string;
  po_line_id: string | null;
}

export interface DocLink {
  id: string;
  po_id: string;
  expires_at: string | null;
  revoked_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface DutyRate {
  id: string;
  layer: string;
  hts_prefix: string;
  country: string;
  rate_pct: number;
  effective_from: string | null;
  effective_to: string | null;
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface File {
  id: string;
  name: string;
  content_type: string;
  size: number;
  data: unknown;
  created_by: string | null;
  created_at: string;
  portal_contact_id: string | null;
  portal_vendor_id: string | null;
}

export interface FileVersion {
  id: string;
  spec_file_id: string;
  filename: string;
  content_type: string;
  size: number;
  sha256: string;
  storage_key: string;
  note: string;
  uploaded_by: string | null;
  uploaded_at: string;
}

export interface ForecastAdjustment {
  id: string;
  scope: "all" | "vendor" | "project" | "product_type" | "tag" | "item";
  scope_value: string;
  pct: number;
  month_from: string | null;
  month_to: string | null;
  note: string;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ForecastBase {
  id: string;
  method: "stockout_adjusted" | "mixed" | "raw";
  level: number;
  recent_rate: number;
  recent_days: number;
  recent_in_stock: number;
  recent_units: number;
  year_rate: number;
  year_days: number;
  year_in_stock: number;
  year_units: number;
  raw_days: number;
  trend: number;
  trend_raw: number | null;
  season_from: "item" | "product_type" | "project" | "store" | "none";
  season_key: string;
  seasonal: number[];
  season_weight: number;
  season_years: number;
  sd: number;
  first_sold: string | null;
  stopped: boolean;
  months_from: string;
  units_by_month: number[];
  out_by_month: number[];
  out_30: number;
  out_90: number;
  acc_source: "snapshots" | "backtest" | "none";
  acc_months: number;
  acc_actual: number;
  acc_forecast: number;
  acc_abs_error: number;
  updated_at: string;
}

export interface ForecastOverride {
  id: string;
  item_id: string;
  month: string;
  units: number;
  note: string;
  created_at: string;
  updated_at: string;
}

export interface ForecastRun {
  id: string;
  as_of: string;
  sales_through: string | null;
  stock_from: string | null;
  stock_through: string | null;
  stale_days: number;
  items: number;
  computed_at: string;
  updated_at: string;
}

export interface ForecastSnapshot {
  item_id: string;
  taken_on: string;
  first_month: string;
  units: number[];
}

export interface FreightRate {
  id: string;
  project_id: string;
  vendor_id: string | null;
  basis: "per_unit" | "pct_value";
  rate: number;
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface GmailAccount {
  id: string;
  user_id: string;
  email: string;
  name: string;
  scopes: string[];
  shared: boolean;
  status: "connected" | "needs_reconnect" | "disconnected";
  last_error: string;
  connected_at: string;
  last_used_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface GmailToken {
  account_id: string;
  refresh_token: string;
  access_token: string;
  access_expires_at: string | null;
  updated_at: string;
}

export interface Item {
  id: string;
  kind: "sell" | "material" | "subassembly" | "service";
  source: "local" | "shopify";
  sku: string;
  name: string;
  description: string;
  uom: string;
  barcode: string;
  photo_url: string;
  procurement: "buy" | "make" | "both";
  std_cost: number | null;
  price: number | null;
  weight_g: number | null;
  hs_code: string;
  country_of_origin: string;
  project_id: string | null;
  tags: string[];
  lifecycle: "npi" | "active" | "eol" | "obsolete";
  notes: string;
  archived: boolean;
  shopify_product_id: string | null;
  shopify_variant_id: string | null;
  shopify_inventory_item_id: string | null;
  shopify_handle: string;
  shopify_product_title: string;
  shopify_variant_title: string;
  shopify_status: string;
  shopify_vendor: string;
  shopify_options: unknown;
  shopify_tracked: boolean | null;
  created_at: string;
  updated_at: string;
  compare_at_price: number | null;
  project_link_id: string | null;
  part_type: "pcb" | "pcba" | "molded" | "metal" | "fastener" | "electronic" | "packaging" | "accessory" | "other";
  project_link_prev_id: string | null;
  pack_type: "" | "box" | "sleeve" | "bag" | "label" | "insert" | "sticker" | "manual" | "other";
  pack_print: "" | "artwork" | "template" | "text" | "label" | "none";
  label_w_mm: number | null;
  label_h_mm: number | null;
  label_note: string;
  part_group_id: string | null;
  group_values: unknown;
}

export interface ItemPlan {
  id: string;
  policy: "auto" | "manual" | "none";
  safety_stock: number | null;
  service_level: number | null;
  snooze_until: string | null;
  snooze_reason: string;
  notes: string;
  created_at: string;
  updated_at: string;
  stock_policy: "forecast" | "min_max" | "target";
  min_qty: number | null;
  max_qty: number | null;
  target_qty: number | null;
  like_item_id: string | null;
  like_pct: number;
  hidden_reason: string;
}

export interface JobRun {
  id: number;
  job: string;
  started_at: string;
  finished_at: string | null;
  ok: boolean | null;
  summary: unknown;
}

export interface JobStatus {
  id: string;
  job: string;
  last_started_at: string | null;
  last_finished_at: string | null;
  last_ok: boolean | null;
  last_ok_at: string | null;
  last_error: string;
  updated_at: string;
}

export interface LandedCost {
  id: string;
  number: string;
  scope: "po" | "receipts";
  po_id: string | null;
  status: "draft" | "applied" | "void";
  forwarder: string;
  invoice_ref: string;
  invoice_date: string | null;
  goods_rates: unknown;
  notes: string;
  applied_at: string | null;
  applied_by: string | null;
  shopify_costs: unknown;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface LandedCostCharge {
  id: string;
  landed_cost_id: string;
  position: number;
  kind: "freight" | "duty" | "tariff" | "fee" | "other";
  description: string;
  amount: number;
  currency: string;
  usd_rate: number;
  method: "value" | "weight" | "qty";
  created_at: string;
  updated_at: string;
}

export interface LandedCostReceipt {
  id: string;
  landed_cost_id: string;
  receipt_id: string;
  created_at: string;
}

export interface Location {
  id: string;
  name: string;
  kind: "hhl" | "vendor_site" | "in_transit";
  shopify_location_id: string | null;
  vendor_id: string | null;
  active: boolean;
  notes: string;
  created_at: string;
  updated_at: string;
  ignored: boolean;
  address: string;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
  is_cm: boolean;
  count_policy: "monthly" | "per_build" | "none";
  address_line1: string;
  address_line2: string;
  address_district: string;
  address_city: string;
  address_region: string;
  address_postal_code: string;
  address_country: string;
}

export interface MakeOrder {
  id: string;
  po_id: string;
  po_line_id: string;
  item_id: string;
  bom_id: string | null;
  bom_revision: number | null;
  cm_location_id: string;
  components: unknown;
  material_cost: number | null;
  qty_output: number;
  stage: "planned" | "materials_ready" | "smt" | "test" | "assembly" | "packing" | "shipped";
  notes: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface PartGroup {
  id: string;
  name: string;
  sku_prefix: string;
  varies_by: string[];
  shared_files: string[];
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface PayAccount {
  id: string;
  name: string;
  kind: "card" | "bank" | "wise" | "paypal" | "other";
  last4: string;
  active: boolean;
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface Payment {
  id: string;
  number: string;
  vendor_id: string | null;
  method: "wise" | "card" | "wire" | "other";
  status: "draft" | "awaiting_funding" | "processing" | "paid" | "cancelled" | "refunded" | "failed";
  amount: number;
  currency: string;
  fee: number;
  fee_currency: string;
  paid_on: string | null;
  reference: string;
  notes: string;
  source: "ui" | "wise_history" | "wise_statement" | "import";
  wise_env: "" | "sandbox" | "live";
  wise_quote_id: string;
  wise_quote_at: string | null;
  wise_transfer_id: number | null;
  wise_recipient_id: number | null;
  wise_state: string;
  wise_state_at: string | null;
  wise_active_cases: unknown;
  wise_batch_id: string | null;
  wise_error: string;
  wise_check: boolean;
  wise_verify: "" | "pending" | "mismatch";
  receipt_status: "" | "pending" | "stored" | "failed";
  fee_cost_id: string | null;
  fee_matched_cost_id: string | null;
  fee_review: string;
  fee_decided_by: string | null;
  fee_decided_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  link_made: unknown;
  pay_account_id: string | null;
  paid_via: string;
}

export interface PaymentAllocation {
  id: string;
  payment_id: string;
  bill_id: string;
  amount: number;
  created_at: string;
  updated_at: string;
}

export interface PlanCover {
  id: string;
  user_id: string;
  vendor_id: string | null;
  days: number | null;
  through: string | null;
  created_at: string;
  updated_at: string;
}

export interface PlanRun {
  id: string;
  kind: string;
  as_of: string;
  started_at: string;
  finished_at: string | null;
  ok: boolean;
  pos_created: number;
  pos_updated: number;
  pos_removed: number;
  lines: number;
  summary: unknown;
  run_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface PlanningSettings {
  id: string;
  review_days: number;
  default_lead_time_days: number;
  cover_days: number;
  horizon_days: number;
  overstock_months: number;
  service_a: number;
  service_b: number;
  service_c: number;
  updated_at: string;
  prior_orders_entered: boolean;
  count_units_per_day: number;
  count_skus_per_day: number;
  count_skip_over: number;
}

export interface Po {
  id: string;
  number: string;
  vendor_id: string;
  kind: "purchase" | "make" | "service";
  status: "draft" | "sent" | "acknowledged" | "in_production" | "shipped" | "received" | "closed" | "cancelled";
  ship_to_location_id: string | null;
  currency: string;
  payment_terms: string;
  incoterms: string;
  deposit_pct: number;
  expected_ship: string | null;
  expected_arrive: string | null;
  vendor_ref: string;
  notes: string;
  internal_notes: string;
  revision: number;
  sent_revision: number | null;
  sent_at: string | null;
  sent_by: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  shopify_transfer_id: string | null;
  shopify_shipment_id: string | null;
  shopify_sync: "none" | "pending" | "done" | "failed";
  shopify_sync_error: string;
  shopify_sync_attempts: number;
  shopify_sync_seq: number;
  auto_key: string;
  auto_run_at: string | null;
  auto_items: string[];
  auto_removed: string[];
  gmail_thread_id: string;
  gmail_message_id: string;
  acknowledged_at: string | null;
  acknowledged_by: string | null;
  ack_note: string;
  plan_checked_at: string | null;
  plan_checked_by: string | null;
  plan_check_key: string;
  plan_check_overridden: boolean;
  plan_check_note: string;
  production_run_id: string | null;
  dated_on: string | null;
  sent_on: string | null;
  acknowledged_on: string | null;
  historical: boolean;
  hhl_share_closed: boolean;
  carrier: string;
  tracking_number: string;
  shipped_on: string | null;
  vendor_ship_date: string | null;
  cover_through: string | null;
  received_on: string | null;
}

export interface PoEmail {
  id: string;
  po_id: string;
  revision: number;
  content_stamp: string;
  account_id: string | null;
  from_email: string;
  to_emails: string[];
  cc_emails: string[];
  subject: string;
  body: string;
  attachment_name: string;
  status: "sending" | "sent" | "failed";
  error: string;
  attempts: number;
  gmail_message_id: string;
  gmail_thread_id: string;
  sent_by: string | null;
  first_attempt_at: string;
  started_at: string;
  sent_at: string | null;
  created_at: string;
  updated_at: string;
  plan_check_key: string;
  plan_check_note: string;
}

export interface PoEmailReply {
  id: string;
  po_id: string;
  po_email_id: string;
  gmail_message_id: string;
  gmail_thread_id: string;
  from_name: string;
  from_email: string;
  received_at: string;
  snippet: string;
  created_at: string;
}

export interface PoEmailSettings {
  id: string;
  default_sender_email: string;
  updated_at: string;
}

export interface PoLine {
  id: string;
  po_id: string;
  position: number;
  item_id: string;
  sku: string;
  name: string;
  vendor_sku: string;
  vendor_name: string;
  photo_url: string;
  qty: number;
  unit_price: number | null;
  promised_date: string | null;
  notes: string;
  qty_shipped: number;
  qty_received: number;
  qty_rejected: number;
  created_at: string;
  updated_at: string;
  spec_revision_id: string | null;
  auto_qty: number | null;
  plan_basis: unknown;
  run_goods: boolean;
  qty_direct: number;
  qty_direct_shipped: number;
  part_specs: unknown | null;
  vendor_date: string | null;
  qty_ready: number;
  billed_price: number | null;
}

export interface PoLineCharge {
  id: string;
  po_line_id: string;
  position: number;
  name: string;
  amount: number;
  per: "unit" | "order";
  layer: "materials" | "assembly" | "packaging" | "tooling";
  created_at: string;
  updated_at: string;
}

export interface PoSentRevision {
  id: string;
  po_id: string;
  revision: number;
  ship_to_name: string;
  ship_to_address: string;
  expected_ship: string | null;
  lines: unknown;
  sent_by: string | null;
  sent_at: string;
}

export interface PoShipment {
  id: string;
  po_id: string;
  shipped_on: string;
  carrier: string;
  tracking_number: string;
  boxes: number | null;
  note: string;
  ship_to_location_id: string | null;
  contact_id: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  received_at: string | null;
  receipt_id: string | null;
}

export interface PoShipmentLine {
  id: string;
  shipment_id: string;
  po_line_id: string;
  qty: number;
  created_at: string;
  updated_at: string;
}

export interface PoShopifyLine {
  po_id: string;
  inventory_item_id: string;
  shipment_line_item_id: string;
  quantity: number;
}

export interface PoUpdate {
  id: string;
  po_id: string;
  kind: "confirmed" | "progress" | "new_date" | "shipped" | "received" | "note";
  note: string;
  new_date: string | null;
  detail: unknown;
  contact_id: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  seen_at: string | null;
  seen_by: string | null;
}

export interface PortalLink {
  id: string;
  expires_at: string;
  used_at: string | null;
  created_by: string | null;
  created_at: string;
  contact_id: string;
}

export interface PortalPref {
  id: string;
  contact_id: string;
  table_key: string;
  view_id: string | null;
  layout: unknown;
  sort: unknown | null;
  created_at: string;
  updated_at: string;
}

export interface PortalSession {
  id: string;
  created_at: string;
  expires_at: string;
  user_agent: string;
  contact_id: string | null;
  user_id: string | null;
  vendor_id: string | null;
}

export interface PortalUpload {
  id: string;
  vendor_id: string;
  contact_id: string | null;
  files: string[];
  note: string;
  status: "new" | "reading" | "done" | "failed";
  result: string;
  handled_at: string | null;
  created_at: string;
  updated_at: string;
  file_names: string[];
  created_by_user: string | null;
}

export interface PortalView {
  id: string;
  contact_id: string;
  table_key: string;
  name: string;
  layout: unknown;
  sort: unknown | null;
  search: string;
  position: number;
  created_at: string;
  updated_at: string;
}

export interface Presale {
  id: string;
  run_id: string;
  name: string;
  channels: string[];
  status: "open" | "shipping" | "done" | "cancelled";
  ships_from: "cm" | "hhl";
  as_of: string | null;
  backers_us: number;
  backers_intl: number;
  backers_unknown: number;
  summary: unknown;
  pledge_total: number | null;
  order_tag: string;
  notes: string;
  external_ref: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface PresaleIncome {
  id: string;
  presale_id: string;
  source: "kickstarter" | "pledgebox" | "shopify" | "other";
  kind: "payout" | "fees" | "refund" | "shipping" | "other";
  received_on: string;
  amount: number;
  currency: string;
  usd_rate: number;
  reference: string;
  description: string;
  note: string;
  external_ref: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface PresaleLine {
  id: string;
  presale_id: string;
  item_id: string;
  us_qty: number;
  intl_qty: number;
  unknown_qty: number;
  assigned_qty: number;
  not_shipping_qty: number;
  note: string;
  position: number;
  created_at: string;
  updated_at: string;
}

export interface PresaleShipment {
  id: string;
  presale_id: string;
  shipped_on: string;
  region: "us" | "intl" | "all";
  packages: number;
  pledge_value: number;
  note: string;
  external_ref: string;
  deposit_ratio: number | null;
  deposit_ratio_filled_on: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface PresaleShipmentLine {
  id: string;
  shipment_id: string;
  item_id: string;
  qty: number;
  unit_cost: number | null;
  unit_cost_note: string;
  unit_cost_filled_on: string | null;
  created_at: string;
  updated_at: string;
}

export interface PricePoint {
  id: string;
  item_id: string;
  vendor_id: string | null;
  source: "quote" | "po";
  source_id: string;
  ref: string;
  unit_price: number;
  currency: string;
  qty: number | null;
  at: string;
  created_at: string;
}

export interface ProductionCost {
  id: string;
  run_id: string;
  category: "materials" | "assembly_labour" | "packing" | "mold_tooling" | "fixture" | "certification" | "samples" | "freight" | "tariff_duty" | "broker" | "payment_fee" | "other" | "unknown" | "backer_shipping";
  vendor_id: string | null;
  description: string;
  amount: number;
  currency: string;
  usd_rate: number;
  basis: "one_time" | "per_unit";
  invoice_number: string;
  invoice_date: string | null;
  po_id: string | null;
  paid_on: string | null;
  paid_method: "" | "wise" | "card" | "wire" | "other";
  paid_ref: string;
  external_ref: string;
  notes: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  presale_id: string | null;
  presale_shipment_id: string | null;
  shipping_kind: "" | "postage" | "ddp" | "packing" | "freight" | "other";
  paid_account_id: string | null;
  paid_via: string;
}

export interface ProductionEvent {
  id: string;
  run_id: string;
  kind: "status" | "po_linked" | "po_unlinked" | "po_sent" | "po_status" | "po_received" | "cm_output" | "cm_scrap" | "opening" | "note" | "photo" | "qc_report" | "golden_sample" | "message";
  title: string;
  body: string;
  at: string;
  by: string | null;
  ref_type: string;
  ref_id: string | null;
  data: unknown;
  external_ref: string;
  created_at: string;
  updated_at: string;
}

export interface ProductionRun {
  id: string;
  project_id: string;
  number: string;
  name: string;
  cm_vendor_id: string | null;
  status: "planning" | "ordering" | "in_production" | "shipping" | "received" | "closed";
  target_ship: string | null;
  target_arrive: string | null;
  plan_basis: unknown;
  opening: unknown;
  notes: string;
  closed_at: string | null;
  external_ref: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  historical: boolean;
  started_on: string | null;
  finished_on: string | null;
  set_aside_note: string;
}

export interface ProductionRunHold {
  id: string;
  run_id: string;
  item_id: string;
  qty: number;
  reason: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface ProductionRunLine {
  id: string;
  run_id: string;
  item_id: string;
  qty: number;
  bom_id: string | null;
  position: number;
  created_at: string;
  updated_at: string;
  set_aside: number;
}

export interface ProductionRunSupply {
  id: string;
  run_id: string;
  item_id: string;
  supply: "hhl_consigns" | "cm_buys" | "cm_makes";
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface Project {
  id: string;
  name: string;
  code: string;
  status: "npi" | "active" | "eol" | "archived";
  color: string;
  notes: string;
  created_at: string;
  updated_at: string;
  cm_vendor_id: string | null;
  launch_date: string | null;
  owner_id: string | null;
  template: string;
  customs_basis: "full" | "cm_invoice";
}

export interface ProjectProduct {
  id: string;
  project_id: string;
  shopify_product_id: string;
  position: number;
  created_at: string;
  updated_at: string;
}

export interface Receipt {
  id: string;
  number: string;
  po_id: string;
  location_id: string | null;
  notes: string;
  closes_po: boolean;
  received_by: string | null;
  received_at: string;
  shopify_status: "none" | "pending" | "done" | "failed";
  shopify_error: string;
  shopify_attempts: number;
  shopify_seq: number;
  created_at: string;
  updated_at: string;
}

export interface ReceiptLine {
  id: string;
  receipt_id: string;
  po_line_id: string;
  item_id: string;
  qty_received: number;
  qty_rejected: number;
  reject_reason: "" | "damaged" | "defective" | "wrong_item" | "other";
  photo_url: string;
  notes: string;
  created_at: string;
  bin_id: string | null;
}

export interface SalesDaily {
  item_id: string;
  day: string;
  units: number;
}

export interface SalesPull {
  id: number;
  history_from: string | null;
  synced_through: string | null;
  backfilled: boolean;
  updated_at: string;
  excluded_tags: string[];
}

export interface SalesSummary {
  id: string;
  as_of: string;
  units_30: number;
  units_90: number;
  units_365: number;
  weekly: number[];
  first_sold: string | null;
  last_sold: string | null;
  updated_at: string;
}

export interface Session {
  id: string;
  user_id: string;
  created_at: string;
  expires_at: string;
  user_agent: string;
}

export interface ShopifyProduct {
  id: string;
  handle: string;
  title: string;
  status: string;
  skip_reason: string | null;
  deleted: boolean;
  synced_at: string;
  vendor: string;
  product_type: string;
  tags: string[];
  variant_count: number;
  shopify_updated_at: string | null;
}

export interface ShopifyShop {
  shop: string;
  access_token: string;
  scopes: string;
  installed_at: string;
}

export interface ShopifyWrite {
  id: string;
  target: "variant" | "product";
  shopify_product_id: string;
  item_id: string | null;
  patch: unknown;
  status: "pending" | "done" | "failed" | "reverted";
  error: string;
  attempts: number;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  before: unknown;
}

export interface Spec {
  id: string;
  item_id: string | null;
  draft_md: string;
  draft_md_zh: string;
  internal_md: string;
  current_revision_id: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  source_url: string;
  shopify_product_id: string | null;
}

export interface SpecFile {
  id: string;
  spec_id: string;
  kind: "pcb_fab" | "pcba" | "kicad" | "design" | "firmware" | "step" | "drawing" | "datasheet" | "artwork" | "dieline" | "fixture" | "other";
  name: string;
  position: number;
  current_version_id: string | null;
  in_draft: boolean;
  created_at: string;
  updated_at: string;
}

export interface SpecImage {
  id: string;
  sha256: string;
  storage_key: string;
  content_type: "image/png" | "image/jpeg" | "image/webp" | "image/gif";
  size: number;
  created_by: string | null;
  created_at: string;
}

export interface SpecRevision {
  id: string;
  spec_id: string;
  rev: string;
  body_md: string;
  body_md_zh: string;
  change_note: string;
  change_notice_id: string | null;
  released_by: string | null;
  released_at: string;
}

export interface SpecRevisionFile {
  id: string;
  spec_revision_id: string;
  file_version_id: string;
  name: string;
  kind: "pcb_fab" | "pcba" | "kicad" | "design" | "firmware" | "step" | "drawing" | "datasheet" | "artwork" | "dieline" | "fixture" | "other";
  position: number;
}

export interface StockBalance {
  id: string;
  item_id: string;
  location_id: string;
  qty: number;
  last_move_at: string | null;
  last_counted_at: string | null;
  updated_at: string;
}

export interface StockBinBalance {
  id: string;
  item_id: string;
  location_id: string;
  bin_id: string;
  qty: number;
  last_move_at: string | null;
  last_counted_at: string | null;
  updated_at: string;
}

export interface StockChange {
  id: string;
  item_id: string;
  location_id: string;
  position: number;
  kind: "set" | "move";
  from_state: "available" | "damaged" | "quality_control" | "safety_stock" | "reserved" | null;
  to_state: "available" | "damaged" | "quality_control" | "safety_stock" | "reserved" | null;
  qty: number;
  seen: number | null;
  status: "pending" | "done" | "failed";
  error: string;
  attempts: number;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface StockCostAdjustment {
  id: string;
  stock_move_id: string;
  item_id: string;
  landed_cost_id: string | null;
  kind: "goods" | "charges" | "billed";
  amount: number;
  unit_delta: number;
  notes: string;
  at: string;
  by: string | null;
  bill_id: string | null;
}

export interface StockCount {
  id: string;
  item_id: string;
  location_id: string;
  counted: number;
  expected: number;
  note: string;
  task_id: string | null;
  counted_by: string | null;
  counted_at: string;
  created_at: string;
  updated_at: string;
}

export interface StockLevel {
  id: string;
  item_id: string;
  location_id: string;
  on_hand: number;
  available: number;
  updated_at: string;
  committed: number;
  damaged: number;
  quality_control: number;
  safety_stock: number;
  reserved: number;
}

export interface StockMove {
  id: string;
  item_id: string;
  from_location_id: string | null;
  to_location_id: string | null;
  qty: number;
  reason: "receipt" | "adjust" | "count" | "consign_ship" | "consume" | "make_output" | "scrap" | "return" | "presale_ship";
  ref_type: string;
  ref_id: string | null;
  unit_cost: number | null;
  counted: number | null;
  notes: string;
  at: string;
  by: string | null;
  from_bin_id: string | null;
  to_bin_id: string | null;
}

export interface StockOutRun {
  item_id: string;
  first_day: string;
  last_day: string;
}

export interface StockPull {
  id: number;
  location_name: string;
  history_from: string | null;
  data_from: string | null;
  synced_through: string | null;
  backfilled: boolean;
  updated_at: string;
}

export interface SuggestedPoHidden {
  id: string;
  user_id: string;
  vendor_id: string;
  until: string | null;
  created_at: string;
  updated_at: string;
}

export interface TablePref {
  id: string;
  user_id: string;
  table_key: string;
  view_id: string | null;
  layout: unknown;
  sort: unknown | null;
  created_at: string;
  updated_at: string;
}

export interface TableView {
  id: string;
  user_id: string;
  table_key: string;
  name: string;
  layout: unknown;
  sort: unknown | null;
  search: string;
  position: number;
  created_at: string;
  updated_at: string;
}

export interface ToolingItem {
  id: string;
  project_id: string;
  kind: "mold" | "fixture" | "certification" | "sample" | "other";
  name: string;
  vendor_id: string | null;
  amount: number;
  currency: string;
  usd_rate: number;
  invoice_number: string;
  invoice_date: string | null;
  paid_by_run_id: string | null;
  spread_units: number;
  applies_when: unknown;
  kept_vendor_id: string | null;
  kept_note: string;
  paid_on: string | null;
  paid_method: "" | "wise" | "card" | "wire" | "other";
  paid_ref: string;
  retired: boolean;
  external_ref: string;
  notes: string;
  created_at: string;
  updated_at: string;
  paid_account_id: string | null;
  paid_via: string;
}

export interface Vendor {
  id: string;
  name: string;
  short_name: string;
  kind: "supplier" | "contract_mfr" | "both";
  currency: string;
  payment_terms: string;
  incoterms: string;
  website: string;
  timezone: string;
  language: string;
  notes: string;
  archived: boolean;
  created_at: string;
  updated_at: string;
  deposit_pct: number;
  default_ship_to_location_id: string | null;
  lead_time_days: number | null;
  moq: number | null;
  order_cycle_days: number | null;
  aliases: string[];
  po_sender_email: string;
  country: string;
}

export interface VendorAddress {
  id: string;
  vendor_id: string;
  kind: "billing" | "ship_from" | "factory" | "remit" | "other";
  label: string;
  line1: string;
  line2: string;
  city: string;
  region: string;
  postal_code: string;
  country: string;
  notes: string;
  created_at: string;
  updated_at: string;
  district: string;
}

export interface VendorClosure {
  id: string;
  label: string;
  closed_from: string;
  back_on: string;
  country: string;
  vendor_id: string | null;
  replaces_id: string | null;
  notes: string;
  created_at: string;
  updated_at: string;
}

export interface VendorContact {
  id: string;
  vendor_id: string;
  name: string;
  role: string;
  email: string;
  phone: string;
  wechat: string;
  is_po_recipient: boolean;
  notes: string;
  created_at: string;
  updated_at: string;
  portal: boolean;
  portal_lang: "en" | "zh";
  portal_last_login_at: string | null;
}

export interface VendorItem {
  id: string;
  vendor_id: string;
  item_id: string;
  vendor_sku: string;
  vendor_name: string;
  unit_price: number | null;
  currency: string;
  price_breaks: unknown;
  moq: number;
  order_multiple: number;
  lead_time_days: number | null;
  quote_ref: string;
  quote_expires: string | null;
  is_preferred: boolean;
  notes: string;
  created_at: string;
  updated_at: string;
  vendor_info: string;
  vendor_photos: string[];
  vendor_stock: number | null;
  vendor_stock_at: string | null;
  vendor_edited_at: string | null;
}

export interface VendorPrice {
  id: string;
  vendor_id: string;
  vendor_item_id: string;
  currency: string;
  price_breaks: unknown;
  moq: number | null;
  lead_time_days: number | null;
  effective_from: string | null;
  note: string;
  was: unknown;
  status: "waiting" | "accepted" | "declined" | "withdrawn" | "replaced";
  reply: string;
  decided_by: string | null;
  decided_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  created_by_user: string | null;
}

export interface VendorProduct {
  id: string;
  vendor_id: string;
  vendor_sku: string;
  name: string;
  family: string;
  variant: string;
  info: string;
  photos: string[];
  unit_price: number | null;
  currency: string;
  moq: number;
  lead_time_days: number | null;
  stock: number | null;
  stock_at: string | null;
  status: "new" | "ignored";
  created_at: string;
  updated_at: string;
  created_by: string | null;
  price_breaks: unknown;
  upload_id: string | null;
}

export interface VendorRecipient {
  id: string;
  vendor_id: string;
  currency: string;
  wise_recipient_id: number;
  name: string;
  last4: string;
  country: string;
  linked_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface WebhookEvent {
  id: string;
  topic: string;
  payload: unknown;
  received_at: string;
  processed_at: string | null;
  attempts: number;
  error: string | null;
}

export interface WikiAttachment {
  id: string;
  sha256: string;
  storage_key: string;
  content_type: string;
  size: number;
  imported_at: string;
}

export interface WiseBatch {
  id: string;
  name: string;
  wise_group_id: string;
  status: "new" | "completed" | "failed";
  error: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface WiseConnection {
  id: number;
  env: "" | "sandbox" | "live";
  profile_id: number | null;
  profile_name: string;
  access: "unknown" | "read_only" | "full" | "failed";
  checked_at: string | null;
  error: string;
  last_event_at: string | null;
  updated_at: string;
}

export interface WiseEvent {
  id: string;
  delivery_id: string;
  event_type: string;
  test: boolean;
  transfer_id: number | null;
  state: string;
  occurred_at: string | null;
  outcome: string;
  received_at: string;
  processed_at: string | null;
}

export interface WiseLease {
  payment_id: string;
  token: string;
  held_by: string;
  until: string;
}

export interface WiseTransfer {
  id: string;
  wise_transfer_id: number;
  source: "api" | "statement" | "webhook";
  transfer_date: string | null;
  reference: string;
  recipient_id: number | null;
  payee_name: string;
  amount: number;
  currency: string;
  source_amount: number | null;
  fee: number;
  state: string;
  note: string;
  payment_id: string | null;
  match_status: "new" | "suggested" | "no_match" | "linked" | "ignored";
  suggestions: unknown;
  created_at: string;
  updated_at: string;
  reason: "" | "before_hhl_ops" | "own_account" | "refund" | "contractor" | "not_business" | "other";
  reason_note: string;
  reason_by: string | null;
  reason_at: string | null;
}

export interface WorkstationCode {
  id: string;
  user_id: string;
  code_hash: string;
  expires_at: string;
  used_at: string | null;
  created_by: string | null;
  created_at: string;
}

/** Tables streamed to browsers (registered with sync_table() in a migration). */
export interface SyncedTables {
  api_token: ApiToken;
  app_user: AppUser;
  attachment: Attachment;
  b2b_demand: B2bDemand;
  bill: Bill;
  bill_line: BillLine;
  bin: Bin;
  bom: Bom;
  bom_line: BomLine;
  bom_option_map: BomOptionMap;
  bom_override: BomOverride;
  build_charge: BuildCharge;
  change_notice: ChangeNotice;
  change_notice_item: ChangeNoticeItem;
  cm_count: CmCount;
  cm_count_line: CmCountLine;
  cm_report: CmReport;
  cm_report_line: CmReportLine;
  consign_shipment: ConsignShipment;
  consign_shipment_line: ConsignShipmentLine;
  count_day: CountDay;
  count_task: CountTask;
  doc_access: DocAccess;
  doc_link: DocLink;
  duty_rate: DutyRate;
  file_version: FileVersion;
  forecast_adjustment: ForecastAdjustment;
  forecast_base: ForecastBase;
  forecast_override: ForecastOverride;
  forecast_run: ForecastRun;
  freight_rate: FreightRate;
  gmail_account: GmailAccount;
  item: Item;
  item_plan: ItemPlan;
  job_status: JobStatus;
  landed_cost: LandedCost;
  landed_cost_charge: LandedCostCharge;
  landed_cost_receipt: LandedCostReceipt;
  location: Location;
  make_order: MakeOrder;
  part_group: PartGroup;
  pay_account: PayAccount;
  payment: Payment;
  payment_allocation: PaymentAllocation;
  plan_cover: PlanCover;
  plan_run: PlanRun;
  planning_settings: PlanningSettings;
  po: Po;
  po_email: PoEmail;
  po_email_reply: PoEmailReply;
  po_email_settings: PoEmailSettings;
  po_line: PoLine;
  po_line_charge: PoLineCharge;
  po_sent_revision: PoSentRevision;
  po_shipment: PoShipment;
  po_shipment_line: PoShipmentLine;
  po_update: PoUpdate;
  portal_upload: PortalUpload;
  presale: Presale;
  presale_income: PresaleIncome;
  presale_line: PresaleLine;
  presale_shipment: PresaleShipment;
  presale_shipment_line: PresaleShipmentLine;
  price_point: PricePoint;
  production_cost: ProductionCost;
  production_event: ProductionEvent;
  production_run: ProductionRun;
  production_run_hold: ProductionRunHold;
  production_run_line: ProductionRunLine;
  production_run_supply: ProductionRunSupply;
  project: Project;
  project_product: ProjectProduct;
  receipt: Receipt;
  receipt_line: ReceiptLine;
  sales_summary: SalesSummary;
  shopify_product: ShopifyProduct;
  shopify_write: ShopifyWrite;
  spec: Spec;
  spec_file: SpecFile;
  spec_revision: SpecRevision;
  spec_revision_file: SpecRevisionFile;
  stock_balance: StockBalance;
  stock_bin_balance: StockBinBalance;
  stock_change: StockChange;
  stock_cost_adjustment: StockCostAdjustment;
  stock_count: StockCount;
  stock_level: StockLevel;
  stock_move: StockMove;
  suggested_po_hidden: SuggestedPoHidden;
  table_pref: TablePref;
  table_view: TableView;
  tooling_item: ToolingItem;
  vendor: Vendor;
  vendor_address: VendorAddress;
  vendor_closure: VendorClosure;
  vendor_contact: VendorContact;
  vendor_item: VendorItem;
  vendor_price: VendorPrice;
  vendor_product: VendorProduct;
  vendor_recipient: VendorRecipient;
  wise_batch: WiseBatch;
  wise_connection: WiseConnection;
  wise_event: WiseEvent;
  wise_transfer: WiseTransfer;
}

/** Column defaults, so a row created in the browser looks like the one the database will store. "now" = the current time. */
export const DEFAULTS: { [T in keyof SyncedTables]: Partial<Record<keyof SyncedTables[T], unknown>> } = {
  "api_token": {
    "last_used_at": null,
    "revoked_at": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "app_user": {
    "name": "",
    "active": true,
    "avatar_url": "",
    "last_login_at": null,
    "created_at": "now",
    "updated_at": "now",
    "can_pay": false,
    "kind": "person"
  },
  "attachment": {
    "kind": "other",
    "filename": "",
    "content_type": "application/octet-stream",
    "size": 0,
    "sha256": "",
    "note": "",
    "doc_date": null,
    "uploaded_by": null,
    "created_at": "now"
  },
  "b2b_demand": {
    "note": "",
    "done": false,
    "created_at": "now",
    "updated_at": "now"
  },
  "bill": {
    "kind": "full",
    "invoice_number": "",
    "bill_date": null,
    "due_date": null,
    "currency": "USD",
    "amount": 0,
    "status": "draft",
    "description": "",
    "notes": "",
    "paid_on": null,
    "approved_by": null,
    "approved_at": null,
    "match_key": "",
    "match_note": "",
    "match_accepted_by": null,
    "match_accepted_at": null,
    "source": "manual",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "bill_line": {
    "position": 0,
    "kind": "goods",
    "description": "",
    "po_id": null,
    "po_line_id": null,
    "receipt_id": null,
    "production_cost_id": null,
    "tooling_item_id": null,
    "credit_bill_id": null,
    "qty": null,
    "unit_price": null,
    "amount": 0,
    "marked_paid": false,
    "created_at": "now",
    "updated_at": "now"
  },
  "bin": {
    "name": "",
    "is_default": false,
    "active": true,
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "bom": {
    "shopify_product_id": null,
    "item_id": null,
    "revision": 1,
    "status": "draft",
    "effective_from": null,
    "make_vendor_id": null,
    "phantom": false,
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "section_order": [],
    "project_ids": [],
    "change_note": ""
  },
  "bom_line": {
    "position": 0,
    "component_item_id": null,
    "qty": 1,
    "scrap_pct": 0,
    "ref_designator": "",
    "is_packaging": false,
    "supply": "hhl_consigns",
    "applies_when": {},
    "option_name": "",
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "section": ""
  },
  "bom_option_map": {
    "created_at": "now",
    "updated_at": "now"
  },
  "bom_override": {
    "qty": null,
    "component_item_id": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "build_charge": {
    "shopify_product_id": null,
    "item_id": null,
    "position": 0,
    "amount": null,
    "per": "unit",
    "layer": "assembly",
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "change_notice": {
    "body_md": "",
    "status": "draft",
    "effective": "next_po",
    "effective_date": null,
    "released_by": null,
    "released_at": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "source_url": ""
  },
  "change_notice_item": {},
  "cm_count": {
    "status": "submitted",
    "make_order_id": null,
    "notes": "",
    "entered_by": null,
    "decided_by": null,
    "decided_at": null,
    "decision_notes": "",
    "created_at": "now",
    "updated_at": "now",
    "decisions": {}
  },
  "cm_count_line": {
    "in_transit": 0,
    "unit_cost": null,
    "in_shopify": false,
    "created_at": "now",
    "outcome": "",
    "adjusted": null
  },
  "cm_report": {
    "make_order_id": null,
    "qty_output": 0,
    "auto": false,
    "notes": "",
    "reported_at": "now",
    "reported_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "cm_report_line": {
    "reason": "",
    "in_shopify": false,
    "notes": "",
    "created_at": "now"
  },
  "consign_shipment": {
    "direction": "to_cm",
    "status": "shipped",
    "carrier": "",
    "tracking": "",
    "eta": null,
    "notes": "",
    "shipped_at": "now",
    "shipped_by": null,
    "received_at": null,
    "received_by": null,
    "receive_notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "consign_shipment_line": {
    "position": 0,
    "qty_received": null,
    "hhl_bin_id": null,
    "unit_cost": null,
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "count_day": {
    "made_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "count_task": {
    "count_id": null,
    "created_at": "now",
    "updated_at": "now",
    "units_90": 0,
    "top": false,
    "last_counted": null,
    "score": 0,
    "picked_by": null,
    "dropped": false
  },
  "doc_access": {
    "doc_link_id": null,
    "po_id": null,
    "spec_revision_id": null,
    "file_version_id": null,
    "at": "now",
    "po_line_id": null
  },
  "doc_link": {
    "expires_at": null,
    "revoked_at": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "duty_rate": {
    "layer": "Base duty",
    "hts_prefix": "",
    "country": "",
    "rate_pct": 0,
    "effective_from": null,
    "effective_to": null,
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "file_version": {
    "content_type": "application/octet-stream",
    "note": "",
    "uploaded_by": null,
    "uploaded_at": "now"
  },
  "forecast_adjustment": {
    "scope": "all",
    "scope_value": "",
    "month_from": null,
    "month_to": null,
    "note": "",
    "active": true,
    "created_at": "now",
    "updated_at": "now"
  },
  "forecast_base": {
    "method": "raw",
    "level": 0,
    "recent_rate": 0,
    "recent_days": 0,
    "recent_in_stock": 0,
    "recent_units": 0,
    "year_rate": 0,
    "year_days": 0,
    "year_in_stock": 0,
    "year_units": 0,
    "raw_days": 0,
    "trend": 1,
    "trend_raw": null,
    "season_from": "none",
    "season_key": "",
    "seasonal": [],
    "season_weight": 0,
    "season_years": 0,
    "sd": 0,
    "first_sold": null,
    "stopped": false,
    "units_by_month": [],
    "out_by_month": [],
    "out_30": 0,
    "out_90": 0,
    "acc_source": "none",
    "acc_months": 0,
    "acc_actual": 0,
    "acc_forecast": 0,
    "acc_abs_error": 0,
    "updated_at": "now"
  },
  "forecast_override": {
    "note": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "forecast_run": {
    "sales_through": null,
    "stock_from": null,
    "stock_through": null,
    "stale_days": 0,
    "items": 0,
    "computed_at": "now",
    "updated_at": "now"
  },
  "freight_rate": {
    "vendor_id": null,
    "basis": "per_unit",
    "rate": 0,
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "gmail_account": {
    "name": "",
    "scopes": [],
    "shared": false,
    "status": "connected",
    "last_error": "",
    "connected_at": "now",
    "last_used_at": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "item": {
    "source": "local",
    "sku": "",
    "description": "",
    "uom": "pcs",
    "barcode": "",
    "photo_url": "",
    "procurement": "buy",
    "std_cost": null,
    "price": null,
    "weight_g": null,
    "hs_code": "",
    "country_of_origin": "",
    "project_id": null,
    "tags": [],
    "lifecycle": "active",
    "notes": "",
    "archived": false,
    "shopify_product_id": null,
    "shopify_variant_id": null,
    "shopify_inventory_item_id": null,
    "shopify_handle": "",
    "shopify_product_title": "",
    "shopify_variant_title": "",
    "shopify_status": "",
    "shopify_vendor": "",
    "shopify_options": {},
    "shopify_tracked": null,
    "created_at": "now",
    "updated_at": "now",
    "compare_at_price": null,
    "project_link_id": null,
    "part_type": "other",
    "project_link_prev_id": null,
    "pack_type": "",
    "pack_print": "",
    "label_w_mm": null,
    "label_h_mm": null,
    "label_note": "",
    "part_group_id": null,
    "group_values": {}
  },
  "item_plan": {
    "policy": "manual",
    "safety_stock": null,
    "service_level": null,
    "snooze_until": null,
    "snooze_reason": "",
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "stock_policy": "forecast",
    "min_qty": null,
    "max_qty": null,
    "target_qty": null,
    "like_item_id": null,
    "like_pct": 100,
    "hidden_reason": ""
  },
  "job_status": {
    "last_started_at": null,
    "last_finished_at": null,
    "last_ok": null,
    "last_ok_at": null,
    "last_error": "",
    "updated_at": "now"
  },
  "landed_cost": {
    "scope": "po",
    "po_id": null,
    "status": "draft",
    "forwarder": "",
    "invoice_ref": "",
    "invoice_date": null,
    "goods_rates": {},
    "notes": "",
    "applied_at": null,
    "applied_by": null,
    "shopify_costs": [],
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "landed_cost_charge": {
    "position": 0,
    "kind": "freight",
    "description": "",
    "amount": 0,
    "currency": "USD",
    "usd_rate": 1,
    "method": "value",
    "created_at": "now",
    "updated_at": "now"
  },
  "landed_cost_receipt": {
    "created_at": "now"
  },
  "location": {
    "kind": "hhl",
    "shopify_location_id": null,
    "vendor_id": null,
    "active": true,
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "ignored": false,
    "address": "",
    "contact_name": "",
    "contact_phone": "",
    "contact_email": "",
    "is_cm": false,
    "count_policy": "monthly",
    "address_line1": "",
    "address_line2": "",
    "address_district": "",
    "address_city": "",
    "address_region": "",
    "address_postal_code": "",
    "address_country": ""
  },
  "make_order": {
    "bom_id": null,
    "bom_revision": null,
    "components": [],
    "material_cost": null,
    "qty_output": 0,
    "stage": "planned",
    "notes": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "part_group": {
    "sku_prefix": "",
    "shared_files": [],
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "pay_account": {
    "last4": "",
    "active": true,
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "payment": {
    "vendor_id": null,
    "method": "wise",
    "status": "draft",
    "amount": 0,
    "currency": "USD",
    "fee": 0,
    "fee_currency": "USD",
    "paid_on": null,
    "reference": "",
    "notes": "",
    "source": "ui",
    "wise_env": "",
    "wise_quote_id": "",
    "wise_quote_at": null,
    "wise_transfer_id": null,
    "wise_recipient_id": null,
    "wise_state": "",
    "wise_state_at": null,
    "wise_active_cases": [],
    "wise_batch_id": null,
    "wise_error": "",
    "wise_check": false,
    "wise_verify": "",
    "receipt_status": "",
    "fee_cost_id": null,
    "fee_matched_cost_id": null,
    "fee_review": "",
    "fee_decided_by": null,
    "fee_decided_at": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "link_made": {},
    "pay_account_id": null,
    "paid_via": ""
  },
  "payment_allocation": {
    "created_at": "now",
    "updated_at": "now"
  },
  "plan_cover": {
    "vendor_id": null,
    "days": null,
    "through": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "plan_run": {
    "kind": "auto_reorder",
    "started_at": "now",
    "finished_at": null,
    "ok": true,
    "pos_created": 0,
    "pos_updated": 0,
    "pos_removed": 0,
    "lines": 0,
    "summary": {},
    "run_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "planning_settings": {
    "review_days": 7,
    "default_lead_time_days": 30,
    "cover_days": 60,
    "horizon_days": 90,
    "overstock_months": 12,
    "service_a": 98,
    "service_b": 95,
    "service_c": 90,
    "updated_at": "now",
    "prior_orders_entered": false,
    "count_units_per_day": 250,
    "count_skus_per_day": 4,
    "count_skip_over": 250
  },
  "po": {
    "kind": "purchase",
    "status": "draft",
    "ship_to_location_id": null,
    "currency": "USD",
    "payment_terms": "",
    "incoterms": "",
    "deposit_pct": 0,
    "expected_ship": null,
    "expected_arrive": null,
    "vendor_ref": "",
    "notes": "",
    "internal_notes": "",
    "revision": 0,
    "sent_revision": null,
    "sent_at": null,
    "sent_by": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "shopify_transfer_id": null,
    "shopify_shipment_id": null,
    "shopify_sync": "none",
    "shopify_sync_error": "",
    "shopify_sync_attempts": 0,
    "shopify_sync_seq": 0,
    "auto_key": "",
    "auto_run_at": null,
    "auto_items": [],
    "auto_removed": [],
    "gmail_thread_id": "",
    "gmail_message_id": "",
    "acknowledged_at": null,
    "acknowledged_by": null,
    "ack_note": "",
    "plan_checked_at": null,
    "plan_checked_by": null,
    "plan_check_key": "",
    "plan_check_overridden": false,
    "plan_check_note": "",
    "production_run_id": null,
    "dated_on": null,
    "sent_on": null,
    "acknowledged_on": null,
    "historical": false,
    "hhl_share_closed": false,
    "carrier": "",
    "tracking_number": "",
    "shipped_on": null,
    "vendor_ship_date": null,
    "cover_through": null,
    "received_on": null
  },
  "po_email": {
    "content_stamp": "",
    "account_id": null,
    "from_email": "",
    "to_emails": [],
    "cc_emails": [],
    "subject": "",
    "body": "",
    "attachment_name": "",
    "status": "sending",
    "error": "",
    "attempts": 1,
    "gmail_message_id": "",
    "gmail_thread_id": "",
    "sent_by": null,
    "first_attempt_at": "now",
    "started_at": "now",
    "sent_at": null,
    "created_at": "now",
    "updated_at": "now",
    "plan_check_key": "",
    "plan_check_note": ""
  },
  "po_email_reply": {
    "from_name": "",
    "from_email": "",
    "snippet": "",
    "created_at": "now"
  },
  "po_email_settings": {
    "default_sender_email": "",
    "updated_at": "now"
  },
  "po_line": {
    "position": 0,
    "sku": "",
    "name": "",
    "vendor_sku": "",
    "vendor_name": "",
    "photo_url": "",
    "unit_price": null,
    "promised_date": null,
    "notes": "",
    "qty_shipped": 0,
    "qty_received": 0,
    "qty_rejected": 0,
    "created_at": "now",
    "updated_at": "now",
    "spec_revision_id": null,
    "auto_qty": null,
    "plan_basis": {},
    "run_goods": false,
    "qty_direct": 0,
    "qty_direct_shipped": 0,
    "part_specs": null,
    "vendor_date": null,
    "qty_ready": 0,
    "billed_price": null
  },
  "po_line_charge": {
    "position": 0,
    "amount": 0,
    "per": "unit",
    "layer": "assembly",
    "created_at": "now",
    "updated_at": "now"
  },
  "po_sent_revision": {
    "ship_to_name": "",
    "ship_to_address": "",
    "expected_ship": null,
    "lines": [],
    "sent_by": null,
    "sent_at": "now"
  },
  "po_shipment": {
    "carrier": "",
    "tracking_number": "",
    "boxes": null,
    "note": "",
    "ship_to_location_id": null,
    "contact_id": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "received_at": null,
    "receipt_id": null
  },
  "po_shipment_line": {
    "created_at": "now",
    "updated_at": "now"
  },
  "po_update": {
    "note": "",
    "new_date": null,
    "detail": {},
    "contact_id": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "seen_at": null,
    "seen_by": null
  },
  "portal_upload": {
    "contact_id": null,
    "note": "",
    "status": "new",
    "result": "",
    "handled_at": null,
    "created_at": "now",
    "updated_at": "now",
    "file_names": [],
    "created_by_user": null
  },
  "presale": {
    "name": "",
    "status": "open",
    "ships_from": "cm",
    "as_of": null,
    "backers_us": 0,
    "backers_intl": 0,
    "backers_unknown": 0,
    "summary": {},
    "pledge_total": null,
    "order_tag": "",
    "notes": "",
    "external_ref": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "presale_income": {
    "source": "kickstarter",
    "kind": "payout",
    "amount": 0,
    "currency": "USD",
    "usd_rate": 1,
    "reference": "",
    "description": "",
    "note": "",
    "external_ref": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "presale_line": {
    "us_qty": 0,
    "intl_qty": 0,
    "unknown_qty": 0,
    "assigned_qty": 0,
    "not_shipping_qty": 0,
    "note": "",
    "position": 0,
    "created_at": "now",
    "updated_at": "now"
  },
  "presale_shipment": {
    "region": "us",
    "packages": 0,
    "pledge_value": 0,
    "note": "",
    "external_ref": "",
    "deposit_ratio": null,
    "deposit_ratio_filled_on": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "presale_shipment_line": {
    "unit_cost": null,
    "unit_cost_note": "",
    "unit_cost_filled_on": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "price_point": {
    "vendor_id": null,
    "ref": "",
    "currency": "USD",
    "qty": null,
    "created_at": "now"
  },
  "production_cost": {
    "category": "other",
    "vendor_id": null,
    "description": "",
    "amount": 0,
    "currency": "USD",
    "usd_rate": 1,
    "basis": "one_time",
    "invoice_number": "",
    "invoice_date": null,
    "po_id": null,
    "paid_on": null,
    "paid_method": "",
    "paid_ref": "",
    "external_ref": "",
    "notes": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "presale_id": null,
    "presale_shipment_id": null,
    "shipping_kind": "",
    "paid_account_id": null,
    "paid_via": ""
  },
  "production_event": {
    "kind": "note",
    "title": "",
    "body": "",
    "at": "now",
    "by": null,
    "ref_type": "",
    "ref_id": null,
    "data": {},
    "external_ref": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "production_run": {
    "name": "",
    "cm_vendor_id": null,
    "status": "planning",
    "target_ship": null,
    "target_arrive": null,
    "plan_basis": {},
    "opening": {},
    "notes": "",
    "closed_at": null,
    "external_ref": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "historical": false,
    "started_on": null,
    "finished_on": null,
    "set_aside_note": ""
  },
  "production_run_hold": {
    "qty": 0,
    "reason": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "production_run_line": {
    "qty": 0,
    "bom_id": null,
    "position": 0,
    "created_at": "now",
    "updated_at": "now",
    "set_aside": 0
  },
  "production_run_supply": {
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "project": {
    "code": "",
    "status": "active",
    "color": "",
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "cm_vendor_id": null,
    "launch_date": null,
    "owner_id": null,
    "template": "",
    "customs_basis": "full"
  },
  "project_product": {
    "position": 0,
    "created_at": "now",
    "updated_at": "now"
  },
  "receipt": {
    "location_id": null,
    "notes": "",
    "closes_po": false,
    "received_by": null,
    "received_at": "now",
    "shopify_status": "none",
    "shopify_error": "",
    "shopify_attempts": 0,
    "shopify_seq": 0,
    "created_at": "now",
    "updated_at": "now"
  },
  "receipt_line": {
    "qty_received": 0,
    "qty_rejected": 0,
    "reject_reason": "",
    "photo_url": "",
    "notes": "",
    "created_at": "now",
    "bin_id": null
  },
  "sales_summary": {
    "units_30": 0,
    "units_90": 0,
    "units_365": 0,
    "weekly": [],
    "first_sold": null,
    "last_sold": null,
    "updated_at": "now"
  },
  "shopify_product": {
    "handle": "",
    "title": "",
    "status": "",
    "skip_reason": null,
    "deleted": false,
    "synced_at": "now",
    "vendor": "",
    "product_type": "",
    "tags": [],
    "variant_count": 0,
    "shopify_updated_at": null
  },
  "shopify_write": {
    "item_id": null,
    "status": "pending",
    "error": "",
    "attempts": 0,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "before": {}
  },
  "spec": {
    "item_id": null,
    "draft_md": "",
    "draft_md_zh": "",
    "internal_md": "",
    "current_revision_id": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "source_url": "",
    "shopify_product_id": null
  },
  "spec_file": {
    "kind": "other",
    "position": 0,
    "current_version_id": null,
    "in_draft": true,
    "created_at": "now",
    "updated_at": "now"
  },
  "spec_revision": {
    "body_md_zh": "",
    "change_note": "",
    "change_notice_id": null,
    "released_by": null,
    "released_at": "now"
  },
  "spec_revision_file": {
    "name": "",
    "kind": "other",
    "position": 0
  },
  "stock_balance": {
    "qty": 0,
    "last_move_at": null,
    "last_counted_at": null,
    "updated_at": "now"
  },
  "stock_bin_balance": {
    "qty": 0,
    "last_move_at": null,
    "last_counted_at": null,
    "updated_at": "now"
  },
  "stock_change": {
    "position": 0,
    "from_state": null,
    "to_state": null,
    "seen": null,
    "status": "pending",
    "error": "",
    "attempts": 0,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "stock_cost_adjustment": {
    "landed_cost_id": null,
    "notes": "",
    "at": "now",
    "by": null,
    "bill_id": null
  },
  "stock_count": {
    "note": "",
    "task_id": null,
    "counted_by": null,
    "counted_at": "now",
    "created_at": "now",
    "updated_at": "now"
  },
  "stock_level": {
    "on_hand": 0,
    "available": 0,
    "updated_at": "now",
    "committed": 0,
    "damaged": 0,
    "quality_control": 0,
    "safety_stock": 0,
    "reserved": 0
  },
  "stock_move": {
    "from_location_id": null,
    "to_location_id": null,
    "ref_type": "",
    "ref_id": null,
    "unit_cost": null,
    "counted": null,
    "notes": "",
    "at": "now",
    "by": null,
    "from_bin_id": null,
    "to_bin_id": null
  },
  "suggested_po_hidden": {
    "until": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "table_pref": {
    "view_id": null,
    "layout": {},
    "sort": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "table_view": {
    "layout": {},
    "sort": null,
    "search": "",
    "position": 0,
    "created_at": "now",
    "updated_at": "now"
  },
  "tooling_item": {
    "kind": "mold",
    "name": "",
    "vendor_id": null,
    "amount": 0,
    "currency": "USD",
    "usd_rate": 1,
    "invoice_number": "",
    "invoice_date": null,
    "paid_by_run_id": null,
    "spread_units": 0,
    "applies_when": {},
    "kept_vendor_id": null,
    "kept_note": "",
    "paid_on": null,
    "paid_method": "",
    "paid_ref": "",
    "retired": false,
    "external_ref": "",
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "paid_account_id": null,
    "paid_via": ""
  },
  "vendor": {
    "short_name": "",
    "kind": "supplier",
    "currency": "USD",
    "payment_terms": "",
    "incoterms": "",
    "website": "",
    "timezone": "",
    "language": "en",
    "notes": "",
    "archived": false,
    "created_at": "now",
    "updated_at": "now",
    "deposit_pct": 0,
    "default_ship_to_location_id": null,
    "lead_time_days": null,
    "moq": null,
    "order_cycle_days": null,
    "aliases": [],
    "po_sender_email": "",
    "country": ""
  },
  "vendor_address": {
    "kind": "billing",
    "label": "",
    "line1": "",
    "line2": "",
    "city": "",
    "region": "",
    "postal_code": "",
    "country": "",
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "district": ""
  },
  "vendor_closure": {
    "country": "",
    "vendor_id": null,
    "replaces_id": null,
    "notes": "",
    "created_at": "now",
    "updated_at": "now"
  },
  "vendor_contact": {
    "name": "",
    "role": "",
    "email": "",
    "phone": "",
    "wechat": "",
    "is_po_recipient": false,
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "portal": false,
    "portal_lang": "en",
    "portal_last_login_at": null
  },
  "vendor_item": {
    "vendor_sku": "",
    "vendor_name": "",
    "unit_price": null,
    "currency": "USD",
    "price_breaks": [],
    "moq": 0,
    "order_multiple": 1,
    "lead_time_days": null,
    "quote_ref": "",
    "quote_expires": null,
    "is_preferred": false,
    "notes": "",
    "created_at": "now",
    "updated_at": "now",
    "vendor_info": "",
    "vendor_photos": [],
    "vendor_stock": null,
    "vendor_stock_at": null,
    "vendor_edited_at": null
  },
  "vendor_price": {
    "moq": null,
    "lead_time_days": null,
    "effective_from": null,
    "note": "",
    "was": {},
    "status": "waiting",
    "reply": "",
    "decided_by": null,
    "decided_at": null,
    "created_by": null,
    "created_at": "now",
    "updated_at": "now",
    "created_by_user": null
  },
  "vendor_product": {
    "vendor_sku": "",
    "family": "",
    "variant": "",
    "info": "",
    "photos": [],
    "unit_price": null,
    "currency": "USD",
    "moq": 0,
    "lead_time_days": null,
    "stock": null,
    "stock_at": null,
    "status": "new",
    "created_at": "now",
    "updated_at": "now",
    "created_by": null,
    "price_breaks": [],
    "upload_id": null
  },
  "vendor_recipient": {
    "currency": "USD",
    "name": "",
    "last4": "",
    "country": "",
    "linked_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "wise_batch": {
    "name": "",
    "wise_group_id": "",
    "status": "new",
    "error": "",
    "created_by": null,
    "created_at": "now",
    "updated_at": "now"
  },
  "wise_connection": {
    "env": "",
    "profile_id": null,
    "profile_name": "",
    "access": "unknown",
    "checked_at": null,
    "error": "",
    "last_event_at": null,
    "updated_at": "now"
  },
  "wise_event": {
    "event_type": "",
    "test": false,
    "transfer_id": null,
    "state": "",
    "occurred_at": null,
    "outcome": "",
    "received_at": "now",
    "processed_at": null
  },
  "wise_transfer": {
    "source": "api",
    "transfer_date": null,
    "reference": "",
    "recipient_id": null,
    "payee_name": "",
    "amount": 0,
    "currency": "USD",
    "source_amount": null,
    "fee": 0,
    "state": "",
    "note": "",
    "payment_id": null,
    "match_status": "new",
    "suggestions": [],
    "created_at": "now",
    "updated_at": "now",
    "reason": "",
    "reason_note": "",
    "reason_by": null,
    "reason_at": null
  }
};
